var definitionActivity = {
  activitySelector : null,
  definitionsObj : null,
  currDefIdx : 0,
  selectedAnswerID : null,

  init : function ( activitySelector, definitionsObj ) {
    definitionActivity.activitySelector = activitySelector;
    definitionActivity.definitionsObj = definitionsObj;
    definitionActivity.currDefIdx = 0;

    definitionActivity.hidePositiveFeedback();
    definitionActivity.hideNegativeFeedback();

    definitionActivity.loadDef ( definitionActivity.currDefIdx );

    definitionActivity.refreshEvents();

    Courses.content.customReasonNotComplete = function() {
      return {
        reason : 'Please view and select an answer for each statement in the activity.',
        popupDimensions : {
          width  : '350px',
          height : '50px',
        },
      };
    };
  },

  loadDef : function ( defIdx ) {
    definitionActivity.resetComponents();

    $(definitionActivity.activitySelector + ' #definition h3').html (
      'Definition ' + ( defIdx + 1 )
    );

    $(definitionActivity.activitySelector + ' #definition div').html (
      '<em>"' + definitionActivity.definitionsObj.definitions[defIdx].def + '"</em>'
    );
  },

  resetComponents : function() {
    // $(definitionActivity.activitySelector + ' .mobile-def-answer select').select_by_value ( null );
    $(definitionActivity.activitySelector + ' .mobile-def-answer select').select_by_value ( undefined );
  },

  refreshEvents : function() {
    $(definitionActivity.activitySelector + ' .mobile-def-answer select')
      .off ( 'change.def-sel' )
      .on  ( 'change.def-sel', function ( evt ) {
        if ( $(this).val() !== null ) {console.log(true);
          // - SHOW CHECK ANSWER BTN
          definitionActivity.showCheckAnswerBtn();

          definitionActivity.selectedAnswerID = Number ( $(this).val() );
        }
        else {console.log(false);
          // - HIDE CHECK ANSWER BTN
          definitionActivity.hideCheckAnswerBtn();

          definitionActivity.selectedAnswerID = null;
        }
      });

    $(definitionActivity.activitySelector + ' #check-answer-btn')
      .off ( 'click.check-answer' )
      .on  ( 'click.check-answer', function ( evt ) {
        if ( definitionActivity.checkAnswer() ) {
          definitionActivity.hideNegativeFeedback();
          definitionActivity.disableSelect();
          definitionActivity.hideCheckAnswerBtn();
          TweenMax.delayedCall ( 0.5, definitionActivity.showPositiveFeedback );
          TweenMax.delayedCall ( 3, definitionActivity.hidePositiveFeedback );
          TweenMax.delayedCall ( 3.5, function() {
            if ( definitionActivity.anyMoreQuestions() ) {
              definitionActivity.showNextBtn();
            }
            else {
              Courses.content.setSlideStatus ( Courses.currentCourse.currentSectionIdx, Courses.currentCourse.currentSlideIdx, 2 );

              setTimeout ( function() {
                Courses.popup.showDynamicPopup (
                  'You have answered all of these questions and you can now click the next arrow to move to the next slide.', {
                    width  : '400px',
                    height : '50px',
                  }
                );
              }, 1000 );
            }
          });
        }
        else {
          definitionActivity.hidePositiveFeedback();
          TweenMax.delayedCall ( 0.5, definitionActivity.showNegativeFeedback );
          TweenMax.delayedCall ( 3, definitionActivity.hideNegativeFeedback );
        }
      });

    $(definitionActivity.activitySelector + ' #next-def-btn')
      .off ( 'click.next-def' )
      .on  ( 'click.next-def', function ( evt ) {
        definitionActivity.hidePositiveFeedback();
        definitionActivity.hideNegativeFeedback();

        definitionActivity.hideNextBtn();

        if ( definitionActivity.anyMoreQuestions() ) {
          TweenMax.delayedCall ( 0.5, definitionActivity.nextQuestion );
        }
        else {
          Courses.content.setSlideStatus ( Courses.currentCourse.currentSectionIdx, Courses.currentCourse.currentSlideIdx, 2 );

          setTimeout ( function() {
            Courses.popup.showDynamicPopup (
              'You have answered all of these questions and you can now click the next arrow to move to the next slide.', {
                width  : '400px',
                height : '150px',
              }
            );
          }, 1000 );
        }
      });
  },

  checkAnswer : function() {
    var correctAnswerID = definitionActivity.definitionsObj.definitions[definitionActivity.currDefIdx].answerID;
    console.log('idx', definitionActivity.currDefIdx);
    console.log('answerID', correctAnswerID);
    console.log('selectedAnswerID', definitionActivity.selectedAnswerID);
    console.log('correct', definitionActivity.selectedAnswerID === correctAnswerID);
    return definitionActivity.selectedAnswerID === correctAnswerID;
  },

  anyMoreQuestions : function() {
    return definitionActivity.currDefIdx < definitionActivity.definitionsObj.definitions.length - 1;
  },

  obscureContent : function() {
    // - BLUR, GRAY, FADE
    TweenMax.to ( '.mobile-def-activity .activity-content', 0.5, {
      filter: 'blur(2px) grayscale(1)',
      opacity: 0.1,
    });
  },

  revealContent : function() {
    // - REMOVE BLUR, GRAY, FADE
    TweenMax.to ( '.mobile-def-activity .activity-content', 0.5, {
      filter: 'none',
      opacity: 1,
    });
  },

  showPositiveFeedback : function() {
    definitionActivity.obscureContent();

    // - FEEDBACK MESSAGE, HIDE, SET TEXT, FADE IN
    TweenMax.set ( '#feedback-message', {
      autoAlpha : 0,
      top : ( parseInt($('#definition').css ( 'top' )) + $('#definition').outerHeight() + 12 ) + 'px',
    });

    $('#feedback-message .inner-container').html('<i class="fa fa-check-circle fa-5x"></i> <p>Well done, that\'s correct.</p>');
    TweenMax.to ( '#feedback-message', 0.5, {
      autoAlpha : 1,
    });

    // // - FEEDBACK ICON
    // TweenMax.to ( 'svg.fa-check-circle', 0.5, {
    //   autoAlpha : 1,
    // });
  },

  hidePositiveFeedback : function() {
    // TweenMax.to ( 'svg.fa-check-circle', 0.5, {
    //   autoAlpha : 0,
    // });

    TweenMax.to ( '#feedback-message', 0.5, {
      autoAlpha : 0,
      onComplete : definitionActivity.revealContent,
    });
  },

  showNegativeFeedback : function() {
    definitionActivity.obscureContent();

    // - FEEDBACK MESSAGE, HIDE, SET TEXT, FADE IN
    TweenMax.set ( '#feedback-message', {
      autoAlpha : 0,
      top : ( parseInt($('#definition').css ( 'top' )) + $('#definition').outerHeight() + 12 ) + 'px',
    });

    $('#feedback-message .inner-container').html('<i class="fa fa-times-circle fa-5x"></i> <p>Sorry that\'s not quite right, please try again.</p>');
    TweenMax.to ( '#feedback-message', 0.5, {
      autoAlpha : 1,
    });

    // // - FEEDBACK ICON
    // TweenMax.to ( 'svg.fa-times-circle', 0.5, {
    //   autoAlpha : 1,
    // });
  },

  hideNegativeFeedback : function() {
    // TweenMax.to ( 'svg.fa-times-circle', 0.5, {
    //   autoAlpha : 0,
    // });

    TweenMax.to ( '#feedback-message', 0.5, {
      autoAlpha : 0,
      onComplete : definitionActivity.revealContent,
    });
  },

  showNextBtn : function() {
    TweenMax.to ( definitionActivity.activitySelector + ' #next-def-btn', 0.01, {
      autoAlpha : 1,
    });

    TweenMax.to ( definitionActivity.activitySelector + ' #next-def-btn', 0.5, {
      left : '140px',
      delay: 0.05,
    });
  },

  hideNextBtn : function() {
    TweenMax.to ( definitionActivity.activitySelector + ' #next-def-btn', 0.5, {
      left : '-50px',
    });

    TweenMax.to ( definitionActivity.activitySelector + ' #next-def-btn', 0.01, {
      autoAlpha : 0,
      delay : 0.45,
    });
  },

  showCheckAnswerBtn : function() {
    var elem = $(definitionActivity.activitySelector + ' #check-answer-btn');

    TweenMax.to ( elem, 0.01, {
      autoAlpha : 1,
      onStart : function() {
        elem.css('display', 'block');
      }
    });

    TweenMax.to ( elem, 0.5, {
      left : '140px',
      delay : 0.05,
    });
  },

  hideCheckAnswerBtn : function() {
    var elem = $(definitionActivity.activitySelector + ' #check-answer-btn');

    TweenMax.to ( elem, 0.5, {
      left : '-50px',
    });

    TweenMax.to ( elem, 0.01, {
      autoAlpha : 0,
      delay : 0.45,
      onComplete : function() {
        elem.css('display', 'none');
      }
    });
  },

  enableSelect : function() {
    // - MAKE IT LOOK DISABLED
    $(definitionActivity.activitySelector + ' .mobile-def-answer')
      .removeClass ( "mobile-def-select-disabled" );
    // - DISABLE IT
    $(definitionActivity.activitySelector + ' .mobile-def-answer select')
      .prop ( "disabled", false );
  },

  disableSelect : function() {
    // - MAKE IT LOOK ENABLED
    $(definitionActivity.activitySelector + ' .mobile-def-answer')
      .addClass ( "mobile-def-select-disabled" );
    // - ENABLE IT
    $(definitionActivity.activitySelector + ' .mobile-def-answer select')
      .prop ( "disabled", true );
  },

  nextQuestion : function() {
    definitionActivity.currDefIdx++;

    definitionActivity.loadDef ( definitionActivity.currDefIdx );

    definitionActivity.enableSelect();
  },
};